import { axios } from "@/lib/axios";

export function apiPlaceOrder( params: {
    guessNo: string;
    type: 1 | 2; // 1:YES 2:No
    price: number | string;
    quantity: number; // 份额
    tradeType: 1 | 2; // 交易类型，1：限价单 2：市价单
    expiredTime?: number | string; // 订单过期时间，如果没有就传空或不传
    tradeAmount?: number | string; // 订单交易金额
    tpTriggerPrice?: number | string; // 止盈触发价，仅限价买单生效
    tpQuantity?: number; // 止盈份额，仅限价买单生效
    slTriggerPrice?: number | string; // 止损触发价，仅限价买单生效
    slQuantity?: number; // 止损份额，仅限价买单生效
} ) {
    return axios.post( "/api/front/guest/user/purchase-shares", params );
}

export function apiSellOrder(
    params: {
        guessNo: string;
        type: 1 | 2;
        price: number | string;
        quantity: number;
        tradeType: 1 | 2;
        expiredTime?: number | string;
        recordNo?: string;
    },
) {
    return axios.post( "/api/front/guest/user/sell-shares", params );
}

export interface MarketOrderResultResp {
    filledQuantity?: number;
    orderNo?: string;
    restingQuantity?: number;
    status?: "PROCESSING" | "DONE" | "FAILED";
    updatedAt?: number;
}

export function apiGetMarketOrderResult( params: { orderNo: string } ) {
    return axios.post( "/api/front/guest/user/market-order/result", params );
}

export function apiGetUserPositions( params: { pageNum: number; pageSize: number; userId?: number } ) {
    return axios.post( "/api/front/guest/user/trade-list", params );
}

export function apiGetUserPositionsNew( params: { pageNum: number; pageSize: number; userId?: number } ) {
    return axios.post( "/api/front/guest/user/user-positions", params );
}

export interface GuessOrderInfo {
    eventNo: string;
    eventTitle: string;
    eventImageUrl: string;
    eventStatus: number; // 0:待发布 1:已发布 2:已结束
    liveState?: number; // 1: live, others: not live
    eventCategory?: number;
    orderNo: string;
    guessNo: string;
    guessType: number; // 1:yes 2:no
    guessTitle: string;
    guessTypeDesc?: string;
    direction: number; // 1:买 2:卖
    orderPrice: number;
    marketPrice: number;
    filled: number; // Filled(固定0)
    quantity: number;
    result: number;
    createTime: string;
    expiredTime: string;
    cost: number;
    guessCategoryId?: number;
    guessCategoryName?: string;
    unionType?: number;
    guessGroupNo?: string | null;
    groupTitle?: string | null;
}

export interface UserOrdersResp {
    guessOrderList: GuessOrderInfo[];
}

export interface ResultVOUserOrdersResp {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: UserOrdersResp;
    traceId: string;
}

export function apiGetOrderTicket( params: { pageNum: number; pageSize: number; guessNo?: string } ) {
    return axios.post( "/api/front/guest/user/user-orders", params );
}

export type AllTradeRecordType = "POSITION" | "ORDER";

export interface AllTradeListReq {
    pageNum: number;
    pageSize: number;
    userId?: number;
    guessNo?: string;
}

export interface AllTradeItemApi {
    recordType: AllTradeRecordType;
    eventNo: string;
    eventTitle: string;
    eventCategory?: number;
    liveState?: number;
    eventImageUrl?: string;
    eventStatus?: number;
    guessNo: string;
    guessTitle: string;
    guessCategoryId?: number;
    guessCategoryName?: string;
    unionType?: number;
    guessGroupNo?: string | null;
    groupTitle?: string | null;
    guessType: 1 | 2;
    guessTypeDesc?: string;
    quantity: number;
    averagePrice?: number;
    cost?: number;
    marketPrice?: number;
    marketPriceUpdateTime?: number;
    orderNo?: string;
    direction?: 1 | 2;
    status?: number;
    orderPrice?: number;
    filled?: number;
    expiredTime?: string;
    tradeTime?: string;
}

export interface AllTradeListResp {
    total: number;
    current: number;
    size: number;
    records: AllTradeItemApi[];
}

export function apiGetAllTrades( params: AllTradeListReq ) {
    return axios.post( "/api/front/guest/user/all-trades", params );
}

export function apiGetHistoryOrder( params: { pageNum: number; pageSize: number; userId?: number } ) {
    return axios.post( "/api/front/guest/user/event-trade-history", params );
}

export function apiGetHistoryOrderByGuess(
    params: { pageNum: number; pageSize: number; userId?: number; guessNo?: string },
) {
    return axios.post( "/api/front/guest/user/event-trade-history/by-guess", params );
}

export function apiGetGuessTradeDetail(
    params: { guessNo: string; guessType: 1 | 2; pageNum: number; pageSize: number },
) {
    return axios.post( "/api/front/guest/user/guess-trade-detail", params );
}

/** orderNoType: 1-事件 2-价格 3-订单编号(传 guessNo + orderNo 两个参数) */
export function apiCancelOrder(
    params: {
        orderNo?: string;
        orderNoType: 1 | 2 | 3;
        guessNo?: string;
        guessType?: 1 | 2;
        price?: number;
        direction?: number;
    },
) {
    return axios.post( "/api/front/guest/user/cancel-order", params );
}

type CancelOrderByGuessParams = { guessGroupNo: string; guessNo?: never; guessType?: 1 | 2 } | {
    guessGroupNo?: never;
    guessNo: string;
    guessType?: 1 | 2;
};

export function apiCancelOrderByGuess( params: CancelOrderByGuessParams ) {
    return axios.post( "/api/front/guest/user/cancel-order/by-guess", params );
}

export function apiGetPendingOrderStats( params?: { guessGroupNo?: string; guessNo?: string; guessType?: 1 | 2 } ) {
    return axios.post( "/api/front/guest/user/pending-order-stats", params );
}

export function apiGetGuessOrderBook( params: { guessNo: string } ) {
    return axios.get( "/api/front/guest/order-list", { params } );
}

export function apiGetOrderRealtimePosition( params: { orderNo: string; guessNo: string } ) {
    return axios.post( "/api/front/guest/user/order-transaction", params );
}

export function apiUpdateOrder( params: { orderNo: string; quantity: number; price: number } ) {
    return axios.post( "/api/front/guest/user/update-order", params );
}

export function apiGetUserTradeRecords( params: {
    pageNum: number;
    pageSize: number;
    sortType?: 1 | 2; // 1=降序（最新），2=升序（最早）
    userId?: number;
} ) {
    return axios.post( "/api/front/guest/user/trade-records", params );
}

export function apiMintShares( params: {
    guessNo: string;
    type: 1 | 2; // 1:铸币(merge) 2:销毁(split)
    quantity: number; // 份数
} ) {
    return axios.post( "/api/front/guest/user/mint-shares", params );
}

export function apiGetUserGuessOrder( params: {
    guessNo: string;
    betType?: 1 | 2; // 可选，1：yes；2：no
} ) {
    return axios.post( "/api/front/guest/user/user-guess-order", params );
}

export interface GuessGroupOrderBookLevel {
    betType?: number;
    direction?: number;
    lastOrderTime?: number;
    marketPrice?: number;
    marketPriceUpdateTime?: number;
    price?: number;
    totalAmount?: number;
    totalDealtQuantity?: number;
    totalFeeAmount?: number;
    totalQuantity?: number;
    [property: string]: any;
}

export interface GuessGroupOrderBookResp {
    coverImageUrl?: string;
    groupTitle?: string;
    guessGroupNo?: string;
    guessNo?: string;
    guessTitle?: string;
    orders?: GuessGroupOrderBookLevel[];
    title?: string;
    [property: string]: any;
}

export function apiGetUserGuessOrderByGuessGroup( params: { guessGroupNo: string } ) {
    return axios.post( "/api/front/guest/user/user-guess-order/by-guess-group", params );
}

// 竞猜维度用户订单列表（Your Orders）
export interface GuessUserOrdersReq {
    pageNum: number;
    pageSize: number;
    guessNo: string;
    guessType?: 1 | 2; // 1:yes 2:no
    orderType?: 0 | 1 | 2 | 3 | 4; // 0:ALL 1:Matched 2:Cancelled 3:Unmatched 4:Completed
}

export interface GuessOrderItemApi {
    orderNo: string;
    direction: number; // 1:买 2:卖
    orderType: number; // 1:Matched 2:Cancelled 3:Unmatched 4:Completed
    orderPrice: number | string;
    quantity: number;
    invested: number | string;
    createTime: string | number;
    returns?: number | string; // 收益（用于 Completed/Settled 展示）
    tpRule?: TpSlRuleResponse | string | null;
    slRule?: TpSlRuleResponse | string | null;
    tpSlSource?: string | null;
}

export interface TpSlRuleResponse {
    ruleNo: string;
    guessNo: string;
    guessType: number;
    tpSlType: number;
    triggerPrice: number;
    refOrderNo: string;
    ruleQuantity: number;
    alreadyTriggeredQty: number;
    remainingTriggerQty: number | string;
    status: number;
    createTime: string;
    updateTime: string;
}

export interface GuessUserOrdersResp {
    guessNo: string;
    guessType: number;
    guessTypeDesc: string;
    marketPrice: number;
    total: number;
    current: number;
    size: number;
    records: GuessOrderItemApi[];
}

export function apiGetUserGuessOrders( params: GuessUserOrdersReq ) {
    return axios.post( "/api/front/guess-order/user-guess-orders", params );
}

export function apiSetTpSlRules(
    params: {
        guessNo: string;
        orderNo: string;
        tpTriggerPrice?: number | string;
        tpQuantity?: number;
        slTriggerPrice?: number | string;
        slQuantity?: number;
    },
) {
    return axios.post( "/api/front/tp-sl/set", params );
}

export function apiCancelTpSlRule( params: { orderNo: string; ruleNo: string; tpSlType?: 1 | 2 } ) {
    return axios.post( "/api/front/tp-sl/cancel", params );
}

// 竞猜维度已结束用户交易列表（Closed Trades）
export interface GuessUserClosedTradesReq {
    pageNum: number;
    pageSize: number;
    guessNo: string;
    guessType?: 1 | 2; // 1:yes 2:no
    orderType?: 0 | 1 | 2 | 3; // 0:ALL 1:Cancelled 2:Sold 3:Settled
}

export interface GuessClosedTradeItem {
    orderNo: string;
    orderType: number; // 1:Cancelled 2:Sold 3:Settled
    quantity: number;
    orderPrice: number;
    invested: number;
    returns: number;
    createTime: string;
    direction?: number; // 1:买 2:卖，未返回时默认 2
}

export interface GuessUserClosedTradesResp {
    guessNo: string;
    guessType: number;
    guessTypeDesc: string;
    records: GuessClosedTradeItem[];
}

export function apiGetUserGuessClosedTrades( params: GuessUserClosedTradesReq ) {
    return axios.post( "/api/front/guess-order/user-guess-closed-trades", params );
}

export interface UserPortfolioResp {
    /**
     * 用户累计投入
     */
    investAmount?: number;
    /**
     * 当前挂单总价格
     */
    pendingOrderTotalPrice?: number;
    portfolio?: number;
    potentialPayout?: number;
    /**
     * 参与事件预测数
     */
    predictions?: number;
    /**
     * 市场总交易量
     */
    volume?: number;
    [property: string]: any;
}

export function apiGetUserPortfolio( params?: { userId?: number } ) {
    return axios.get( "/api/front/user/getUserportfolio", { params } );
}

export interface GuessPositionDetailReq {
    pageNum: number;
    pageSize: number;
    guessNo: string;
    guessType?: 1 | 2;
    orderNo?: string;
    tradeNo?: string;
    userId?: number;
    source?: string;
}

export interface ShareConfigDTO {
    shareText?: string;
    shareTitle?: string;
    shareUrl?: string;
    [property: string]: any;
}

export interface PositionInfo {
    averagePrice?: number;
    cost?: number;
    eventCategory?: number;
    eventImageUrl?: string;
    eventNo?: string;
    eventTitle?: string;
    groupTitle?: string;
    guessCategoryId?: number;
    guessCategoryName?: string;
    guessGroupNo?: string;
    guessNo?: string;
    guessTitle?: string;
    guessType?: number;
    guessTypeDesc?: string;
    lastTradeTime?: string;
    liveState?: number;
    marketPrice?: number;
    marketPriceUpdateTime?: number;
    orderNo?: string;
    quantity?: number;
    unionType?: number;
    [property: string]: any;
}

export interface TradeListResp {
    positionList?: PositionInfo[];
    shareLinkData?: ShareConfigDTO;
    shareStatus?: number;
    total?: number;
    totalPositionAmount?: number;
    [property: string]: any;
}

export interface GuessGroupPositionDetailReq {
    pageNum: number;
    pageSize: number;
    guessGroupNo: string;
}

// Position详细列表（按竞猜维度）
export function apiGetGuessPositionDetail( params: GuessPositionDetailReq ) {
    return axios.post( "/api/front/guest/user/trade-list/by-guess", params );
}

// Position详细列表（按聚合竞猜组维度）
export function apiGetGuessGroupPositionDetail( params: GuessGroupPositionDetailReq ) {
    return axios.post( "/api/front/guest/user/trade-list/by-guess-group", params );
}

// Position详细列表（分享场景，按竞猜维度）
export function apiGetGuessPositionShareDetail( params: GuessPositionDetailReq ) {
    return axios.post( "/api/front/guest/user/trade-list/by-guess/share", params );
}

// History详细列表（按竞猜维度）
export function apiGetGuessHistoryDetail(
    params: { pageNum: number; pageSize: number; guessNo: string; userId?: number },
) {
    return axios.post( "/api/front/guest/user/event-trade-history/by-guess", params );
}

// 用户交易历史接口（用户维度）
export interface TradeHistoryItem {
    eventNo: string;
    eventTitle: string;
    eventImageUrl: string;
    orderNo?: string;
    tradeNo?: string;
    guessNo: string;
    guessTitle: string;
    guessType: 1 | 2; // 1:yes 2:no
    tradeType: 1 | 2 | 3 | 4 | 5; // 1:限价单 2:市价单 3:铸币 4:销毁 5:结算
    result: 0 | 1; // 1:赢 0:输，仅 trade_type=5
    cost: number;
    quantity: number;
    averagePrice: number;
    fees: number;
    profit: number;
    guessTypeDesc: string;
    resultWinDesc?: string;
    createTime: string;
}

export function apiGetUserTradeHistory(
    params: { pageNum: number; pageSize: number; userId?: number; guessNo?: string },
) {
    return axios.post( "/api/front/guest/user/user-trade-history", params );
}
